import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect/es';

import LiveClassGroups from '../../domain/services/bbb/meeting/liveClassGroups';
import { selectStudent } from './students.slices';

interface ILiveClassGroups {
  id: string;
  name: string;
  teacher_id: string;
  lesson_id: string;
}

const initialState = {
  groups: [] as ILiveClassGroups[],
  loading: '',
  error: '',
  students: {
    loading: '',
    error: '',
    list: [],
  },
};

export const getGroupsForTeacherByLesson = createAsyncThunk(
  'get-groups-for-teacher-by-lesson-id',
  async (teacher_id: string) => {
    return new LiveClassGroups().getLiveClassGroups({ _eq: teacher_id });
  }
);

export const getStudentsForClass = createAsyncThunk(
  'get-students-for-group',
  async (group_id: string, thunkAPI) => {
    const response = await new LiveClassGroups().getStudentsByGroupId({ _eq1: group_id });
    response.forEach(obj => {
      thunkAPI.dispatch(selectStudent(obj.user_id));
    });
    return [];
  }
);

const TeacherGetGroupsSlice = createSlice({
  name: 'teacher-groups-live-class/get',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getGroupsForTeacherByLesson.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(getGroupsForTeacherByLesson.fulfilled, (state, action) => {
      state.loading = 'success';
      // @ts-ignore
      state.groups = action.payload;
    });
    builder.addCase(getGroupsForTeacherByLesson.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
    builder.addCase(getStudentsForClass.pending, state => {
      state.students.loading = 'pending';
    });
    builder.addCase(getStudentsForClass.fulfilled, (state, action) => {
      state.students.loading = 'success';
      state.students.list = action.payload;
    });
    builder.addCase(getStudentsForClass.rejected, (state, action) => {
      state.students.loading = 'failed';
      state.students.error = action.error.message;
    });
  },
});

const stateExport = state => state.teacherGetGroupsSlice;

export const teacherGetGroupsState = createSelector(stateExport, obj => {
  return {
    model: obj.groups,
    groupStudents: obj.students,
  };
});

export default TeacherGetGroupsSlice.reducer;
